/* Who the booking system says a booked service was requested of.
 *
 * Mangomint records a request per booked service as `staffRequestedType`, and
 * the same again for a second technician on the service. `SpecificStaff` is a
 * request however it was booked (Kevin, 2026-10-18); `Anyone`, `FemaleOnly` and
 * `MaleOnly` are not a request for a person. Mangomint is authoritative: when
 * it reports a service at all, its word stands over the desk's own mark.
 *
 * Pure: the store hands in the row and a way to turn the source's staff id
 * into a technician on the board.
 */

/* `row` is one fetchBookedRequests() entry, or undefined when the source has
 * said nothing about this service. Returns
 *   undefined   no word from the source — the desk's mark decides;
 *   null        the source says it is not a request;
 *   { staffIds } a request, for those board technicians. Empty when the person
 *                asked for has no technician linked to them: still a request,
 *                just not one the board can name. */
export function bookedRequest(row, resolveStaff) {
  if (!row) return undefined;
  var ids = [];
  var any = false;
  [[row.type, row.staffId], [row.additionalType, row.additionalStaffId]].forEach(function (p) {
    if (p[0] !== 'SpecificStaff') return;
    any = true;
    var s = p[1] == null || p[1] === '' ? null : resolveStaff(String(p[1]));
    if (s && ids.indexOf(s.id) === -1) ids.push(s.id);
  });
  return any ? { staffIds: ids } : null;
}

/* Whether a request still holds, given who the book has on the service now
 * (`onBooking`, board technician ids). A booking moved to somebody else is not
 * a request for anybody — moving an appointment did not ask the client — and
 * the poll can be up to a minute behind the book. Asked about one person
 * (`staffId`), it is a request only for somebody who was asked for AND is
 * still on it. Returns the ids it still holds for, or null.
 *
 * A request the board cannot name holds whoever is asked about, the same as a
 * desk mark made on a booking that named nobody. */
export function requestStillHolds(req, onBooking, staffId) {
  if (!req) return null;
  if (!req.staffIds.length) return [];
  var still = req.staffIds.filter(function (id) { return onBooking.indexOf(id) !== -1; });
  if (!still.length) return null;
  if (staffId && still.indexOf(staffId) === -1) return null;
  return still;
}
